"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _tssReact = require("tss-react");
var _tss = require("../styles/tss");
var _utilities = require("../utilities");
const _excluded = ["classes", "className", "animated", "color", "style", "size", "thickness", "value", "variant"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const CIRCLE_DIAMETER = 44;
const circularRotateKeyframes = (0, _tssReact.keyframes)`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const animatedKeyframes = (0, _tssReact.keyframes)`
  0% {
    stroke-dasharray: 0px, 200px;
    stroke-dashoffset: 1px;
  }

  100% {
    stroke-dashoffset: 0px 200px;
  }
`;
const circularDashKeyframes = (0, _tssReact.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0px;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`;
const useStyles = (0, _tss.makeTssStyles)({
  name: 'DsCircularProgress',
  uniqId: 'Xd4k2y'
})((theme, _params, classes) => {
  const {
    colors
  } = theme.busbud;
  return {
    root: {
      display: 'block'
    },
    colorPrimary: {
      color: colors.component.progressBar.primary.progress
    },
    colorSecondary: {
      color: colors.component.progressBar.secondary.progress
    },
    colorTertiary: {
      color: colors.border.primary.opaque,
      [`& .${classes.track}`]: {
        stroke: colors.component.progressBar.secondary.track
      }
    },
    colorQuaternary: {
      color: colors.border.secondary.opaque,
      [`& .${classes.track}`]: {
        stroke: colors.component.progressBar.secondary.track
      }
    },
    svg: {
      display: 'block' // Keeps the progress centered
    },
    circle: {
      stroke: 'currentColor',
      strokeLinecap: 'round'
    },
    animated: {
      animation: `${animatedKeyframes} 1.4s ease-in-out`
    },
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },
    circleIndeterminate: {
      animation: `${circularDashKeyframes} 1.4s ease-in-out infinite`,
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
    },
    track: {
      stroke: colors.component.progressBar.primary.track
    }
  };
});
function getColorClassKey(color) {
  return `color${(0, _utilities.capitalizeFirstWord)(color)}`;
}
const CONTAINER_SIZE_MAP = {
  sm: 24,
  md: 40,
  lg: 64,
  fill: '100%'
};
const THICKNESS_MAP = {
  sm: 2.4,
  md: 3.6,
  lg: 4.8
};

/**
 * CircularProgress informs users about the status of ongoing processes, such as loading an app, submitting a form, or saving updates.
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-feedback-circularprogress--page)
 */
const CircularProgress = /*#__PURE__*/_react.default.forwardRef(function CircularProgress(props, ref) {
  const {
      classes: classesOverrides,
      className,
      animated = false,
      color = 'primary',
      style,
      size = 'md',
      thickness = 'md',
      value = 0,
      variant = 'indeterminate'
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    cx,
    classes
  } = useStyles(undefined, {
    props: {
      classes: classesOverrides
    }
  });
  const containerSize = CONTAINER_SIZE_MAP[size];
  const thicknessValue = THICKNESS_MAP[thickness];
  const circleStyle = {};
  const rootStyle = {};
  const rootProps = {};
  if (variant === 'static') {
    const circumference = 2 * Math.PI * ((CIRCLE_DIAMETER - thicknessValue) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(Math.min(value, 100));
    if (variant === 'static') {
      circleStyle.strokeDashoffset = `${((100 - Math.min(value, 100)) / 100 * circumference).toFixed(3)}px`;
      rootStyle.transform = 'rotate(-90deg)';
    }
  }
  return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
    className: cx(classes.root, classes[getColorClassKey(color)], className),
    style: _objectSpread(_objectSpread({
      height: containerSize,
      width: containerSize === '100%' ? undefined : containerSize
    }, rootStyle), style),
    ref: ref,
    role: "progressbar"
  }, rootProps, other), /*#__PURE__*/_react.default.createElement("svg", {
    height: "100%",
    preserveAspectRatio: "xMinYMin meet",
    className: classes.svg,
    viewBox: `${CIRCLE_DIAMETER / 2} ${CIRCLE_DIAMETER / 2} ${CIRCLE_DIAMETER} ${CIRCLE_DIAMETER}`
  }, /*#__PURE__*/_react.default.createElement("circle", {
    className: classes.track,
    cx: CIRCLE_DIAMETER,
    cy: CIRCLE_DIAMETER,
    r: (CIRCLE_DIAMETER - thicknessValue) / 2,
    strokeWidth: thicknessValue,
    fill: "none"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    className: cx(classes.circle, {
      [classes.circleIndeterminate]: variant === 'indeterminate',
      [classes.circleStatic]: variant === 'static',
      [classes.animated]: animated
    }),
    style: circleStyle,
    cx: CIRCLE_DIAMETER,
    cy: CIRCLE_DIAMETER,
    r: (CIRCLE_DIAMETER - thicknessValue) / 2,
    fill: "none",
    strokeWidth: thicknessValue
  })));
});
var _default = exports.default = CircularProgress;